import React, { useEffect, useState } from "react";
import { Sparkles, Flower2 } from "lucide-react";
import { api } from "@/lib/api";
import { roseBackdrop } from "@/lib/roses";
import { HeartButton } from "@/components/HeartButton";
import { RoseGiftDialog } from "@/components/RoseGiftDialog";

export function FeaturedBloom() {
  const [note, setNote] = useState(null);
  const [giftOpen, setGiftOpen] = useState(false);

  useEffect(() => {
    api.get("/notes/featured").then((r) => setNote(r.data)).catch(() => {});
  }, []);

  if (!note) return null;
  const backdrop = roseBackdrop(note.roses);

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 pb-10 float-up" data-testid="featured-bloom">
      <div className="relative overflow-hidden rounded-3xl border border-pink-400/40 shadow-[0_0_50px_rgba(255,46,147,0.18)]">
        {backdrop ? (
          <>
            <img src={backdrop} alt="" className="absolute inset-0 w-full h-full object-cover brightness-[0.55] saturate-125" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/30" />
          </>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-[#2a0b1f] via-[#140711] to-black" />
        )}
        <div className="relative z-10 p-8 sm:p-12 text-left">
          <p className="flex items-center gap-2 text-[11px] font-mono tracking-[0.3em] uppercase text-pink-300">
            <Sparkles className="w-3.5 h-3.5" /> Featured Bloom · Note of the day
          </p>
          <p className="mt-5 text-sm text-pink-400 font-mono uppercase tracking-[0.2em]">For {note.recipient_name}</p>
          <blockquote data-testid="featured-bloom-message" className="mt-3 font-serif italic font-light text-2xl sm:text-3xl lg:text-4xl leading-snug text-pink-50 max-w-3xl">
            “{note.message}”
          </blockquote>
          <div className="mt-8 flex items-center gap-3 flex-wrap">
            <span className="text-sm text-pink-200 mr-2">— {note.author_name || "Anonymous"}</span>
            <HeartButton note={note} />
            <button
              data-testid="featured-bloom-gift-btn"
              onClick={() => setGiftOpen(true)}
              className="flex items-center gap-1.5 text-xs bg-pink-500/15 hover:bg-pink-500/30 text-pink-200 px-3 py-1.5 rounded-full border border-pink-500/25 transition-colors"
            >
              <Flower2 className="w-3.5 h-3.5" /> Roses
            </button>
          </div>
        </div>
      </div>
      <RoseGiftDialog open={giftOpen} onOpenChange={setGiftOpen} note={note} />
    </section>
  );
}
